import { CalendarCheck, Mail, MapPin, MessageCircle, Phone, Repeat, SquareCheck, Users, Utensils, type LucideIcon } from 'lucide-react';
import type { TipoAtividade } from './tipos';

/** Ajustes do CRM 27/10 (C18, K3): ícone de cada tipo de tarefa, como na origem (formulário, atalho de tarefas e listas). */
export const ICONE_TIPO_ATIVIDADE: Record<TipoAtividade, LucideIcon> = {
  tarefa: SquareCheck,
  ligacao: Phone,
  reuniao: Users,
  follow_up: Repeat,
  email: Mail,
  whatsapp: MessageCircle,
  visita: MapPin,
  almoco: Utensils,
};

export function IconeTipoAtividade({ tipo, className = 'size-4' }: { tipo: TipoAtividade; className?: string }) {
  const Icone = ICONE_TIPO_ATIVIDADE[tipo] ?? CalendarCheck;
  return <Icone className={`shrink-0 text-tinta-2 ${className}`} aria-hidden />;
}

/** "AAAA-MM-DDTHH:mm" (como o `paraLocal`) separado em data e horário, como os dois campos da origem. */
export function separarDataHora(local: string): { data: string; hora: string } {
  return { data: local.slice(0, 10), hora: local.slice(11, 16) };
}

/** Junta data e horário de volta; sem a data, fica vazio (campo obrigatório); sem o horário, 09:00 como a origem. */
export function juntarDataHora(data: string, hora: string): string {
  return data ? `${data}T${hora || '09:00'}` : '';
}
